/** Mensaje cualitativo por rango de puntuación media (spec.md): sin mensaje
 * para 1–1.99, "Bueno" para 2–2.99, "Muy bueno" para 3–3.99, "Fantástico"
 * para 4–5. Aplica por igual a Bazaarvoice y al sistema propio (BD). */
export function getRatingLabel(average: number): string | null {
  if (average < 2) return null
  if (average < 3) return 'Bueno'
  if (average < 4) return 'Muy bueno'
  return 'Fantástico'
}
